import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { MailX } from 'lucide-react';

const Unsubscribe = () => {
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState(searchParams.get('email') || '');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleUnsubscribe = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/unsubscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, reason })
      });

      if (response.ok) {
        setSuccess(true);
      } else {
        setError('Failed to unsubscribe. Please try again.');
      }
    } catch (err) {
      setError('Failed to unsubscribe. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
        <div className="max-w-lg w-full card text-center">
          <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
            <MailX className="h-8 w-8 text-green-600" />
          </div>
          <h1 className="text-2xl font-bold text-green-600 mb-4">Successfully Unsubscribed</h1>
          <p className="text-gray-600 mb-4">
            You have been removed from our mailing list. You will no longer receive marketing emails from us.
          </p>
          <p className="text-sm text-gray-500">
            It may take up to 24 hours for the changes to take effect.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex">
      {/* Left side - Form */}
      <div className="w-full lg:w-1/2 bg-gray-50 flex items-center justify-center p-8">
        <div className="max-w-md w-full">
          <div className="text-center mb-8">
            <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
              <MailX className="h-8 w-8 text-blue-600" />
            </div>
            <h1 className="text-2xl font-bold mb-4">Manage Your Email Preferences</h1>
          </div>
        
        <p className="text-gray-600 mb-6">
          We're sorry to see you go! We respect your decision and will remove you from our mailing list. 
          Your feedback helps us improve our communications.
        </p>
        
        {error && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
            {error}
          </div>
        )}

        <form onSubmit={handleUnsubscribe}>
          <input
            type="email"
            placeholder="Enter your email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent mb-4"
            required
          />

          <select
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent mb-4"
          >
            <option value="">Why are you unsubscribing? (Optional)</option>
            <option value="too_frequent">Too many emails</option>
            <option value="not_relevant">Content not relevant</option>
            <option value="never_signed_up">Never signed up</option>
            <option value="other">Other</option>
          </select>

          <button
            type="submit"
            disabled={loading}
            className="w-full btn-primary"
          >
            {loading ? 'Processing...' : 'Unsubscribe'}
          </button>
        </form>

          <p className="text-sm text-gray-600 mt-4 text-center">
            You will be removed from all marketing emails within 24 hours.
          </p>
        </div>
      </div>
      
      {/* Right side - Pricing Image */}
      <div className="hidden lg:block lg:w-1/2">
        <img 
          src="/images/pricing-image.png" 
          alt="Pricing Overview" 
          className="w-full h-full object-cover"
        />
      </div>
    </div>
  );
};

export default Unsubscribe;